const JEELIZAUTOVTO = (function(){
  const _defaultSpec = {
    // Where we should append the VTO button:
    VTOButtonAnchor: null,

    // how we use the anchor. Possible values are 'this', 'inside', 'before', 'after'
    VTOButtonAnchorType: 'inside',

    // Source code of the virtual try-on button:
    VTOButtonSource: '<button>Virtual try on</button>',

    // HTML source or element displayed with the modal background when the user clicks on the VTO button
    // Useful to implement scale changes depending on man / woman, or display GDPR notices
    // and before the start of the VTO session.
    // it can call these methods:
    //   * JEELIZAUTOVTO.resume_beforeStart() to take of the HTML code and resume VTO
    //   * JEELIZAUTOVTO.cancel_beforeStart() to cancel VTO
    //   * JEELIZAUTOVTO.update_adjustment({scale: <scale>}) to set a custom scale factor
    VTOBeforeStart: null,

    // if true, open the VTO window automatically (and don't display the VTO button)
    isAutoStartVTO: false,

    // color of the background of the VTP modal window:
    modalBackgroundColor: 0x000000,

    // opacity of the VTO modal window:
    modalBackgroundOpacity: 0.5,

    // set it to false to not display VTO widget in full height. otherwise height in CSS pixels
    VTOViewHeight: 0,

    // Model selector, displayed in the VTO view
    // It can be either HTML source code (provided as a string), or DOM elements
    // it can call JEELIZAUTOVTO.load_modelFromUrl(otherModelProductPageUrl) to change the current model
    VTOSwitchModels: null,

    // image used when we look for the face:
    faceSearchImageMask: 'https://appstatic.jeeliz.com/jeewidget/images/target512.jpg',

    // color of the loading image:
    faceSearchImageColor: 0xeeeeee,

    // enable shadows on the glasses:
    isShadow: true,

    // where to find client files - should end by /:
    autoVTOClientURL: 'https://autovtoclient.jeeliz.com/',

    // where to find AutoVTO server:
    autoVTOServerURL: 'https://autovtoapi.jeeliz.com',

    // whether URL rewriting is enabled or not:
    autoVTOServerURLRewritingEnabled: true,

    // where to find AutoVTO stats server:
    autoVTOServerStatsURL: 'https://autovtostats.jeeliz.com',

    // list of URL parameters kept for the product page URL:
    protectedURLParams: ['variant'],

    // if true, allow # in the URL
    isProtectURLPound: false,

    // function receiving location.href as argument, and returning a tweaked locationHref
    // the goal of this function is to avoid duplicates in product pages URL:
    // If we have different product page URLs for the same product, this function can be used
    // to return a unique URL for all of them.
    locationHrefTweaker: null,

    // if set, load the model by SKU instead of by page URL
    autoVTOSKU: null,

    // if set to false, do not prefetch neural network and glasses model
    // to make loading faster
    isPreFetch: true,

    // use this value instead of the current URL:
    debugPageURL: null,

    // if true, display the VTO button with a debug SKU:
    debugAlwaysDisplay: false,

    debugReplaceModelURLPath: null,

    // misc callbacks:
    onVTOWidgetReady: null, // when VTO widget is initialized
    onVTOWidgetInit: null,  // when VTO widget init has been done

    // callbacks to implement custom analytics:
    onVTOSessionStart: null,  // the VTO session really starts
    onVTOSessionEnd: null,    // the VTO session ends or the page is closed.
    onVTOError: null,         // for some reason the VTO session cannot start
    onVTOButtonDisplay: null, // the VTO button is displayed
    onVTOButtonClick: null,   // the user clicks on the VTO button
  };

  const _version = '1.2.4';

  let _spec = null;
  let _VTOSessionStartTimestamp = -1;
  
  const _widget = {
    isSetuped: false,
    isVTOAlreadyStarted: false,
    modalDOMElt: null,
    VTOButtonDOMElt: null,
    widgetDOMElt: null,
    beforeStartDOMElt: null
  };

  const _model = {
    pageCanonicalURL: '',
    sku: null,
    isManaged: false,
    tweaker: null,
    autoVTOURL: null,
    glassesDBSKU: null,
    needsUpdate: false
  };

  const _states = {
    errorFatal: -3,
    errorRecoverable: -2,
    notLoaded: -1,
    loading: 0,
    idle: 1,
    paused: 2,
    running: 3
  };
  let _state = _states.notLoaded;

  const _preAdjust = {
    scale: 1
  }

  const _materialsUpdates0 = { // keys are material names, not tweaker group names:
    'nosepad': null,
    'lens_mat': null,
    'front_mat': null,
    'metal_mat': null,
    'right_temple_mat': null,
    'left_temple_mat': null,
  };
  const _materialsUpdates = Object.assign({}, _materialsUpdates0);

  /*window.debugAutoVTO = {
    widget: _widget,
    model: _model,
    getState: function(){
      return _state;
    },
    getSpec: function(){
      return _spec;
    }
  } //*/


  function get_currentLocationHref(){
    return document.location.href;
  }


  function canonize_productPageUrl(url){
    let loc = (_spec.locationHrefTweaker) ? _spec.locationHrefTweaker(url) : url;
    const fullURL = loc;
    
    // remove anchor:
    let anchor = '';
    const locAnchorSplit = loc.split('#');
    if (locAnchorSplit.length >= 2 && _spec.isProtectURLPound){
      anchor = locAnchorSplit[1];
    }
    loc = locAnchorSplit[0];

    // remove URL parameters:
    loc = loc.split('?').shift();

    // remove last /:
    loc = loc.replace(/\/$/, "");

    // some parameters can be used to characterize the product page. keep them
    if (_spec.protectedURLParams && _spec.protectedURLParams.length > 0){
      _spec.protectedURLParams.sort();
      const newParams = [];
      const urlParams = new URL(fullURL).searchParams;
      _spec.protectedURLParams.forEach((paramKey) => {
        const paramVal = urlParams.get(paramKey)
        if (paramVal){
          newParams.push(paramKey + '=' + paramVal);
        }
      });
      if (newParams.length > 0){
        loc += '?' + newParams.join('&');
      }
    }

    // append anchor if necessary:
    if (_spec.isProtectURLPound && anchor.length > 0){
      loc += '#' + anchor;
    }
    return loc;
  }


  function get_thisPageCanonicalURL(){
    if (_spec.debugPageURL){
      return _spec.debugPageURL;
    }
    const canonicalUrl = canonize_productPageUrl(get_currentLocationHref());
    console.log('INFO in AutoVTO.js: canonical page URL =', canonicalUrl);
    return canonicalUrl;
  }


  function request_server(productPageUrl, sku){
    if (_spec.debugAlwaysDisplay){
      console.warn('WARNING in AutoVTO: debugAlwaysDisplay flag is set to true. A debug glasses model will be used instead of the real one. This feature should only be used to debug the VTO button or the VTO UI.');
      return Promise.resolve({
        modelURL: 'DEBUG',
        isEnabled: true
      });
    }
    const data = sku || encodeURIComponent(productPageUrl);
    const varName = (sku) ? 'sku' : 'productPageURL';

    let fetchPath = (sku) ? '/getBySku' : '/getByProductPage';
    fetchPath += (_spec.autoVTOServerURLRewritingEnabled) ? '/' :  ('?' + varName + '=');
    fetchPath += data;
    
    return fetch_json(_spec.autoVTOServerURL + fetchPath);
  }


  function append_htmlSourceCode(DOMAnchor, htmlSource, anchorType) {
    if (anchorType === 'this'){
      // display DOMAnchor if CSS display=none:
      if (DOMAnchor.style.display === 'none'){
        DOMAnchor.style.display = 'block';
      }
      if (DOMAnchor.style.visibility === 'hidden'){
        DOMAnchor.style.visibility = 'visible';
      }
      return DOMAnchor;
    }
    let DOMElt = null;
    if (typeof(htmlSource) === 'string'){
      const DOMPage = new DOMParser().parseFromString(htmlSource, "text/html");
      if (DOMPage.body.children.length === 1){
        DOMElt = DOMPage.body.firstElementChild;
      } else {
        DOMElt = document.createElement('div');
        let DOMChildren = [];
        for (const DOMChild of DOMPage.body.children) {
          DOMChildren.push(DOMChild);
        }
        DOMChildren.forEach(function(DOMChild){
          DOMElt.appendChild(DOMChild);
        })
      }
    } else {
      DOMElt = htmlSource;
    }

    if (DOMElt){
      switch(anchorType){
        case 'before':
          DOMAnchor.parentNode.insertBefore(DOMElt, DOMAnchor);
          break;
        case 'after':
          DOMAnchor.parentNode.insertBefore(DOMElt, DOMAnchor.nextSibling);
          break;
        case 'inside':
        default:
          DOMAnchor.appendChild(DOMElt);
      }
    }
    return DOMElt;
  }


  function create_VTOButton(DOMAnchor, anchorType, buttonSource, onClick){

    if (!DOMAnchor){
      console.warn('WARNING in Jeeliz AutoVTO: we cannot get the VTO button anchor. VTO button is appended to document.body');
      DOMAnchor = document.body;
    }

    const DOMButton = append_htmlSourceCode(DOMAnchor, buttonSource, anchorType);
    DOMButton.addEventListener('click', function(event){
      if (_spec.onVTOButtonClick){
        _spec.onVTOButtonClick(event);
      }
      onClick();
    });
    if (_spec.onVTOButtonDisplay){
      _spec.onVTOButtonDisplay(DOMButton);
    }
    return DOMButton;
  }


  function fetch_text(url){
    return fetch(url, {
        method: 'GET',
        mode: "cors",
        cache: "default"
      })
      .then(function(response){
        return response.text();
      })
  }//*/

  
  function fetch_json(url){
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('cache-control', 'no-cache');
    return fetch(url, {
      method: 'GET',
      mode: "cors",
      headers: headers,
      cache: "no-store"
    })
    .then(function(response){
      return response.json();
    })
  }


  function append_jeelizVTOWidget(){
    return fetch_text(_spec.autoVTOClientURL + 'insertJeelizVTOWidgetModalCode.html')
      .then(function(htmlSource){
        _widget.modalDOMElt = append_htmlSourceCode(document.body, htmlSource, 'inside');
        _widget.widgetDOMElt = _widget.modalDOMElt.firstElementChild;
        return _widget.modalDOMElt;
      });
  }


  function append_script(src, isDefer){
    const DOMScript = document.createElement('script');
    DOMScript.setAttribute('src',  src);
    if (isDefer){
      DOMScript.setAttribute('defer', true);
    }
    document.head.appendChild(DOMScript);
    return new Promise(function(accept, reject){
      DOMScript.addEventListener('load', accept);
      DOMScript.addEventListener('error', reject);
    });
  }


  function append_fontAwesome(){
    return append_script(_spec.autoVTOClientURL + 'libs/fontawesome-free-6.4.2-web/js/all.min.js', true);
  }


  function append_jeelizVTOMainScript(){
    return append_script(_spec.autoVTOClientURL + 'dist/JeelizVTOWidget.js', false);
  }


  function append_jeelizVTOBeforeStart(){
    if (!_spec.VTOBeforeStart){
      return;
    }
    _widget.beforeStartDOMElt = append_htmlSourceCode(_widget.widgetDOMElt, _spec.VTOBeforeStart, 'inside');
  }


  function append_CSSStyleSheet(href){
    const DOMStyle = document.createElement('link');
    DOMStyle.setAttribute('rel', 'stylesheet');
    DOMStyle.setAttribute('href',  href);
    //return append_toBody(DOMStyle);
    document.head.appendChild(DOMStyle);
    return Promise.resolve(DOMStyle);
  }


  function append_jeelizVTOStyle(){
    return Promise.all([
      append_CSSStyleSheet(_spec.autoVTOClientURL + 'css/JeelizVTOWidget.css')
    ]);
  }


  function toggle_VTOWidgetVisibility(isVisible){
    _widget.modalDOMElt.style.display = (isVisible) ? 'flex' : 'none';
  }


  function tweak_model(){
    console.log('INFO in Jeeliz AutoVTO: tweak model');
    JEELIZVTOWIDGET['tweak_autoVTOModel'](_model.tweaker, _preAdjust);
    apply_materialUpdates();
  }


  function get_currentTimeStampMs(){
    return Date.now();
  }


  function on_VTOSessionStart(){
     _state = _states.running;
     _VTOSessionStartTimestamp = get_currentTimeStampMs();
     if (_spec.onVTOSessionStart){
      _spec.onVTOSessionStart();
     }
  }


  function log_VTOSessionEvent(sku, isManaged, VTOSessionDurationMs){
    const data = {
      s: sku,
      m: isManaged ? 1 : 0,
      d: VTOSessionDurationMs
    };
    return fetch(_spec.autoVTOServerStatsURL + '/logVTOSessionEvent', {
      method: 'POST',
      mode: "cors",
      cache: "no-store",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data)
    }).then(function() {
      console.log('VTO session logged');
      return true;
    });
  }


  function on_VTOSessionEnd(){
    if (_VTOSessionStartTimestamp <= 0){
      // the page exit without any VTO session active
      return;
    }
    const VTOSessionDurationMs = get_currentTimeStampMs() - _VTOSessionStartTimestamp;
    if (_spec.onVTOSessionEnd){
      _spec.onVTOSessionEnd(VTOSessionDurationMs);
    }
    log_VTOSessionEvent(_model.sku, _model.isManaged, VTOSessionDurationMs);
    _VTOSessionStartTimestamp = -1; // make sure we don't count the time twice
  }


  function start_VTO(){
    console.log('INFO in Jeeliz AutoVTO: Start VTO session');
    toggle_VTOWidgetVisibility(true);
    _widget.isVTOAlreadyStarted = true;
    if (!JEELIZVTO.check_isMobile()){
      document.documentElement.style.overflow = 'hidden';
    }

    if (_state === _states.idle){
      _state = _states.loading;
      init_jeelizVTOWidget(_model.autoVTOURL, _model.glassesDBSKU)
        .then(function(){
          tweak_model();
          on_VTOSessionStart();
        })
        .catch(function(err){
          console.log('FATAL ERROR initializing Jeeliz VTO widget:', err);
          _state = _states.errorFatal;
        })
    } else if (_state === _states.paused){
      _state = _states.loading;
      resume_VTO();

      // Check if the current page URL has changed or not:
      /*const newPageCanonicalURL = get_thisPageCanonicalURL();
      if (newPageCanonicalURL === _model.pageCanonicalURL){
        resume_VTO();
      } else {
        update_modelPageUrl(newPageCanonicalURL).then(resume_VTO);
      }*/
    }
  }


  function resume_VTO(){
    JEELIZVTOWIDGET.resume(true)
      .then(function(){
        if (_model.needsUpdate){
          _model.needsUpdate = false;
          update_model().then(function(){
            tweak_model();
            on_VTOSessionStart();
          });
        } else {
          on_VTOSessionStart();
        }
      }).catch(function(err){
        console.log('FATAL ERROR resuming Jeeliz VTO widget: ', err);
        _state = _states.errorFatal;
      });
  }


  function stop_VTO(){
     console.log('INFO in Jeeliz AutoVTO: Stop VTO session');
    _state = _states.loading;

    toggle_VTOWidgetVisibility(false);
    on_VTOSessionEnd();
    JEELIZVTOWIDGET.pause(true).then(function(){
      _state = _states.paused;
      if (!JEELIZVTO.check_isMobile()){
        document.documentElement.style.overflow = 'unset';
      };
    })
  }


  function init_jeelizVTOWidget(modelURL, glassesDBSKU){
    return new Promise(function(accept, reject){
      JEELIZVTOWIDGET.start({
        isShadow: _spec.isShadow,
        sku: (_spec.debugAlwaysDisplay && !glassesDBSKU) ? 'rayban_chris_noir_gun_bleu_mirroir' : glassesDBSKU,
        modelStandalone: (_spec.debugAlwaysDisplay) ? null : modelURL,
        searchImageMask: _spec.faceSearchImageMask,
        searchImageColor: _spec.faceSearchImageColor,
        callbackReady: function(){
          console.log('INFO: JEELIZVTOWIDGET is ready :)');
          // add a LUT to change video rendering:
          //JEELIZVTOWIDGET.set_LUT('images/LUTs/LUTGrayscale.png');
          //JEELIZVTOWIDGET.set_LUT('images/LUTs/LUTImprove.jpg');
          if (_spec.onVTOWidgetReady){
            _spec.onVTOWidgetReady();
          }
          accept();
        },
        onError: function(errorLabel){ // this function catches errors, so you can display custom integrated messages
          console.log('ERROR in JEELIZVTO: ' + errorLabel);
          if (_spec.onVTOError){
            _spec.onVTOError(errorLabel);
          }
          switch(errorLabel) {
            case 'WEBCAM_UNAVAILABLE':
              // the user has no camera, or does not want to share it.
              break;
        
            case 'NOFILE':
              // the user send an image, but it is not here
              break;

            case 'WRONGFILEFORMAT':
              // the user upload a file which is not an image or corrupted
              break;

            case 'INVALID_SKU':
              // the provided SKU does not match with a glasses model
              break;

            case 'FALLBACK_UNAVAILABLE':
              // we cannot switch to file upload mode. browser too old?
              break;

            case 'PLACEHOLDER_NULL_WIDTH':
            case 'PLACEHOLDER_NULL_HEIGHT':
              // Something is wrong with the placeholder
              // (element whose id='JeelizVTOWidget')
              break;
              
            case 'FATAL':
            default:
              // a bit error happens:(
              break;
          } // end switch
          reject(errorLabel);
        } // end onError()
      }); // end JEELIZVTOWIDGET.start call

      if (_spec.onVTOWidgetInit){
        _spec.onVTOWidgetInit();
      }
    }); // end returned promise
  }


  function convert_colorToNumArray(color){
    switch (typeof(color)){
      case 'string':
        return convert_colorStrHTMLToNumArray(color);
      case 'number':
        const colorStr = convert_colorNumToStringHex(color);
        return convert_colorStrHTMLToNumArray(colorStr);
      default:
        return color;
    }
  }


  function convert_colorStrHTMLToNumArray(colorHTML) {
    const colorHex = colorHTML.replace('#', '');
    return convert_colorStrHexToNumArray(colorHex);
  }


  function convert_colorStrHexToNumArray(colorHexStr){
    return [0, 2, 4].map(function(iStart){
      return parseInt(colorHexStr.slice(iStart, iStart+2), 16);
    });
  }


  function convert_colorNumToStringHex(val){ // 0x0a1122 -> '0a1122'
    const hexString = val.toString(16);
    const hexString6 = hexString.padStart(6, '0');
    return hexString6;
  }


  function convert_colorOpacityNumToCSSString(colorNum, opacityNum){ // 0x0a1122, 0.2 -> rgba(...)
    const colorHexStr = convert_colorNumToStringHex(colorNum);
    const colorArrNum = convert_colorStrHexToNumArray(colorHexStr);
    const colorArrHex = colorArrNum.map(function(v){return v.toString();}).join(',');
    return 'rgba(' + [colorArrHex, opacityNum.toString()].join(',') + ')';
  }


  function change_modalStyle(){
    const modalStyle = _widget.modalDOMElt.style;
    modalStyle.backgroundColor =  convert_colorOpacityNumToCSSString(_spec.modalBackgroundColor, _spec.modalBackgroundOpacity);
  }


  function change_widgetStyle(){
    const widgetStyle = _widget.widgetDOMElt.style;
    if (_spec.VTOViewHeight === 0){
      widgetStyle.boxShadow = 'none';
    } else {
      widgetStyle.flexGrow = '0';
      widgetStyle.height = _spec.VTOViewHeight.toString() + 'px';
    }
  }


  function setup_eventListeners(){
    _widget.widgetDOMElt.addEventListener('click', function(event){
      event.stopPropagation();
    });
    _widget.modalDOMElt.addEventListener('click', stop_VTO);
    document.getElementById('JeelizVTOWidgetExitIcon').addEventListener('click', stop_VTO);
    if (_spec.onVTOSessionEnd){
      window.addEventListener("beforeunload", on_VTOSessionEnd);
    }
  }


  function do_preFetch(){
    setTimeout(JEELIZVTOWIDGET.preFetch.bind(null, _model.autoVTOURL), 200);
  }


  function preFetch(){
    if (document.readyState === "complete" || document.readyState === "loaded") {
      do_preFetch();
    } else {
      document.addEventListener("DOMContentLoaded", do_preFetch);
    }
  }


  function on_productPageUrlUpdate(){
    const newHref = get_thisPageCanonicalURL();
    if (_model.pageCanonicalURL === newHref) {
      return;
    }
    console.log('INFO in AutoVTO: Location changed! New URL =', _model.pageCanonicalURL);
    if (![_states.idle, _states.paused, _states.errorRecoverable].includes(_state)){
      return;
    }
    const newPageCanonicalURL = get_thisPageCanonicalURL();
    if (newPageCanonicalURL === _model.pageCanonicalURL){
      return;
    }
    console.log('INFO in AutoVTO: new location matches a new model');
    update_modelPageUrl(newPageCanonicalURL);
  }


  function setup_observerURLChange(){
    const observer = new MutationObserver(function(mutations) {
      if (!_model.pageCanonicalURL){
        return;
      }
      on_productPageUrlUpdate();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }


  function update_modelPageUrl(newPageCanonicalURL){
    _state = _states.loading;
    _model.pageCanonicalURL = newPageCanonicalURL;
    toggle_VTOButtonVisibility(false);
    return request_server(_model.pageCanonicalURL, _spec.autoVTOSKU)
      .then(process_serverReply)
      .catch(function(err){
        console.log('WARNING in Jeeliz AutoVTO: Cannot update product page. Error =', err);
      });
  }


  function toggle_VTOButtonVisibility(isVisible){
    if (!_widget.VTOButtonDOMElt){
      return;
    }
    _widget.VTOButtonDOMElt.style.display = (isVisible) ? 'block' : 'none';
  }


  function process_serverReply(reply) {
    const return_fail = function(err){
      if (_spec.onVTOError){
        _spec.onVTOError(err);
      }
      return Promise.reject(err);
    }

    if (reply['err']){
      const err = reply['err'];
      const warningLabels = ['PRODUCT_ADDED_TO_DB', 'PRODUCT_STATUS_BUSY', 'PRODUCT_STATUS_NEW'];
      const recoverableErrorLabels = ['PRODUCT_STATUS_ERROR'].concat(warningLabels);
      if (warningLabels.includes(err)){
        console.warn('WARNING in Jeeliz AutoVTO: ', err);
      } else {
        console.log('ERROR in Jeeliz AutoVTO: ', err);
      }
      _state = (recoverableErrorLabels.includes(err)) ? _states.errorRecoverable : _states.errorFatal;
      return return_fail(err);
    }

    if (reply['isEnabled'] === undefined){
      console.error('ERROR in Jeeliz AutoVTO: invalid server reply. Reply =\n', reply);
      _state = _states.errorFatal;
      return return_fail('INVALID_SERVER_REPLY');
    }

    if (!_spec.isAutoStartVTO && !reply['isEnabled']){
      console.warn('WARNING in Jeeliz AutoVTO: this model is disabled. Do not display VTO button');
      return Promise.resolve();
    }

    let modelURL = reply['modelURL'] || null;
    const glassesDBSKU = reply['glassesDBSKU'] || null;
    _model.sku = glassesDBSKU || reply['autoVTOSKU'];
    _model.isManaged = (glassesDBSKU) ? true : false;
    if (modelURL && _spec.debugReplaceModelURLPath){
      modelURL = modelURL.replace(_spec.debugReplaceModelURLPath[0], _spec.debugReplaceModelURLPath[1]);
    }
    
    _model.tweaker = reply['tweaker'] || null;
    _model.autoVTOURL = modelURL;
    _model.glassesDBSKU = glassesDBSKU;

    console.log('INFO in AutoVTO: Model =', _model);

    if (_widget.isSetuped){
      toggle_VTOButtonVisibility(true);
      _model.needsUpdate = true;
      _state = (_widget.isVTOAlreadyStarted) ? _states.paused : _states.idle;
    } else {
      _widget.isSetuped = true;
      return setup_widget();
    }
  }


  function load_modelStandalone(modelURL){
    return new Promise(function(accept, reject){
      JEELIZVTOWIDGET['load_modelStandalone'](modelURL, accept);
    })
  }


  function load_modelGlassesDB(glassesDBSKU){
    return new Promise(function(accept, reject){
      JEELIZVTOWIDGET['load'](glassesDBSKU, accept);
    })
  }


  function update_model(){
    // the model has changed (canonical URL has changed) => we load the next model
    if (_model.autoVTOURL){
      return load_modelStandalone(_model.autoVTOURL);
    } else if (_model.glassesDBSKU){
      return load_modelGlassesDB(_model.glassesDBSKU);
    }
  }


  function apply_materialUpdates(){
    JEELIZVTO['get_materialsSpec']().then(function(matsSpecs){
      matsSpecs.forEach(function(matSpecs, matInd){
        const name = matSpecs['name'];
        if (!name){
          return;
        }
        if (_materialsUpdates[name]){
          JEELIZVTO['update_material'](matInd, _materialsUpdates[name], false);
        }
      });
    });
  }


  function setup_widget(){
    console.log('INFO in AutoVTO: setup widget...');
    return Promise.all([
        append_jeelizVTOStyle(),
        append_jeelizVTOWidget(),
        append_jeelizVTOMainScript()
      ])
      .then(function(){
        append_jeelizVTOBeforeStart();
        change_modalStyle();
        change_widgetStyle();
        if (_spec.VTOSwitchModels){
          const DOMAdjustButton = document.getElementById('JeelizVTOWidgetAdjust');
          append_htmlSourceCode(DOMAdjustButton, _spec.VTOSwitchModels, 'after');
        }
        _state = _states.idle;
        if (_spec.isAutoStartVTO){
          start_VTO();
        } else {
          setup_eventListeners();
          if (_spec.isPreFetch){
            preFetch();
          }
          _widget.VTOButtonDOMElt = create_VTOButton(_spec.VTOButtonAnchor, _spec.VTOButtonAnchorType, _spec.VTOButtonSource, start_VTO);
        }
      });
  }


  const that = {
    init: function(specArg){
      if (!document.body){
        console.error('ERROR: Jeeliz AutoVTO should be initialized after the page is loaded');
        return;
      }
      if (_state !== _states.notLoaded){
        console.warn('WARNING: Jeeliz AutoVTO cannot be initialized multiple times');
        return;
      }
      console.log('INIT Jeeliz AutoVTO v' + _version);
      _state = _states.loading;

      _spec = Object.assign({}, _defaultSpec, specArg);

      _model.pageCanonicalURL = get_thisPageCanonicalURL();
      setup_observerURLChange();
      request_server(_model.pageCanonicalURL, _spec.autoVTOSKU)
        .then(process_serverReply)
        .catch(function(err){
          
        });
    },


    load_modelFromUrl: function(modelPageUrl){
      if (_state !== _states.running){
        console.log('WARNING in JEELIZAUTOVTO.load_modelFromUrl(): this method can only be called in running state');
        return;
      }
      that.reset_materialsUpdates();
      const canonicalModelPageUrl = canonize_productPageUrl(modelPageUrl);
      return update_modelPageUrl(canonicalModelPageUrl)
        .then(update_model)
        .then(tweak_model)
        .then(function(){
          _state = _states.running;
        });
    },


    reset_materialsUpdates: function(){
      Object.assign(_materialsUpdates, _materialsUpdates0);
    },


    update_materialProperties: function(part, updatedProps){
      if (_materialsUpdates[part] === undefined){
        console.log('WARNING - part should be among these values: ' + Object.keys(_materialsUpdates0).join(', '));
      }
      const updatedPropsApplied = Object.assign({}, updatedProps);
      if (updatedProps['color']){
        updatedPropsApplied['diffuseColor'] = convert_colorToNumArray(updatedProps['color']);
      }
      _materialsUpdates[part] = updatedPropsApplied || null;
      if ([_states.running, _states.paused].includes(_state)){
        apply_materialUpdates();
      }
    },


    update_adjustment(adjustmentSettings){
      if (adjustmentSettings.scale){
        _preAdjust.scale = adjustmentSettings.scale;
        if ([_states.running, _states.paused].includes(_state)){
          const currentTweakerScale = (_model && _model.tweaker) ? _model.tweaker.scale : 1.0;
          JEELIZVTO['update_tweaker']({
            'preScale': _preAdjust.scale * currentTweakerScale
          });
        }
      }
    },


    resume_beforeStart(){
      if (!_widget.beforeStartDOMElt){
        return;
      }
      _widget.beforeStartDOMElt.style.display = 'none';
    },


    cancel_beforeStart(){
      if (!_widget.beforeStartDOMElt){
        return;
      }
      stop_VTO();
    },


    on_productPageUrlUpdate: on_productPageUrlUpdate
  }
  return that;
})() 